import { observer } from 'mobx-react';
import React from 'react';
import { PromiseMessage, routerStore } from 'lib/components';
import { promiseStates, ReactNodeGenerator, urlHelper } from '../../../lib/helpers';
import { ClassroomHeader } from '../parts/ClassroomHeader';
import { ClassroomLoaderControls } from '../parts/ClassroomLoaderControls';
import { ClassroomVideo } from '../video/ClassroomVideo';
import { TeacherClassroomSceneStore } from './TeacherClassroomSceneStore';
import { TeacherClassroomTabs } from './TeacherClassroomTabs';

const ps = promiseStates;

function* renderer(store: TeacherClassroomSceneStore, isPreview: boolean, isHomework: boolean): ReactNodeGenerator {
  if (!isPreview && !isHomework) {
    yield (<ClassroomVideo key="classroom-video"
      store={store.hubStore.video} />);

    yield <ClassroomLoaderControls key="classroom-loader-controls"
      store={store} />;
  }

  if (!store.canConnectToHub)
    return;

  const classroom = store.classroomLoader!.value!;

  yield <ClassroomHeader key="classroom-header"
    store={store.hubStore}
    classroom={classroom}
    isPreview={isPreview}
    isHomework={isHomework} />;

  const { snapshotState } = store;
  yield (
    <PromiseMessage key="lesson-loader-state"
      label="Loading lesson"
      state={snapshotState}
      align="right" />);

  if (ps.isRejected(snapshotState)) {
    yield (
      <div className="row" key="lesson-load-action">
        <div className="col-auto ml-auto">
          <button type="button" className="btn btn-primary"
            onClick={store.loadLesson}>
            Load lesson
          </button>
        </div>
      </div>
    );
  }

  const classroomState = store.hubStore.state.classroomState!;
  if (classroomState === null)
    return;

  yield (<TeacherClassroomTabs store={store} key="classroom-lesson-tabs" isPreview={isPreview} isHomework={isHomework} />);
}

interface Props {
  id: number;
}

@observer
export class TeacherClassroomScene extends React.Component<Props> {
  readonly store: TeacherClassroomSceneStore;

  readonly isPreview: boolean;
  readonly isHomework: boolean;

  constructor(props: Readonly<Props>) {
    super(props);
    this.isPreview = urlHelper.isTeacherClassroomPreview;
    this.isHomework = urlHelper.isTeacherClassroomHomework;
    this.store = new TeacherClassroomSceneStore(props.id, this.isPreview, this.isHomework);
  }

  componentDidMount() {
    this.store.loadClassroom();
  }

  render() {
    return Array.from(renderer(this.store, this.isPreview, this.isHomework));
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
